<template>
  <div id="operator-shifts-page">
    <vue-persian-calender
      :events-list="events"
      date-format="YYYY-MM-DDTHH:mm:ss.SSSZ"
      @on-event-click="showSiftDetail"
    />
    <!-- SHOW EVENT -->
    <vs-popup
      class="calendar-event-dialog"
      :title="$t('personnel.shift')"
      :active.sync="activePromptSiftDetail"
      @close="activePromptSiftDetail = false"
    >
      <div class="w-full">
        <p>{{ $t('places.place') }}: {{ showEvent.title }} {{ showEvent.specialty }}</p>
      </div>

      <!-- Start Shift -->
      <div class="w-full mt-4">
        <p>{{ $t('personnel.shift_start') }}: {{ showEvent.startDateTime | datetime }}</p>
      </div>
      <!-- End Shift -->
      <div class="w-full mt-4">
        <p>{{ $t('personnel.shift_end') }}: {{ showEvent.endDateTime | datetime }}</p>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VuePersianCalender from 'vue-persian-calendar'

import moduleBusiness from '@/store/business/moduleBusiness'
import modulePlaces from '@/store/places/modulePlaces'
import moduleServices from '@/store/services/moduleServices'
import moduleEmployee from '@/store/employee/moduleEmployee'

export default {
  name: 'EmployeeShifts',
  components: {
    VuePersianCalender
  },
  data() {
    return {
      place: null,
      employeeIds: null,
      events: [],
      activePromptSiftDetail: false,
      showEvent: {}
    }
  },
  methods: {
    setServices() {
      this.events = []
      this.$store.commit('service/SET_SERVICES_QUERY', {
        employeeId: { $in: this.employeeIds }
      })
      this.$store.commit('service/SET_SERVICES_SORT', { created_at: -1 })
      this.$store.commit('service/SET_SERVICES_LIMIT', 1000)
      this.$store
        .dispatch('service/fetchServices')
        .then(res => {
          if (res.data.services.length === 0) this.$vs.loading.close()
          else
            res.data.services.forEach(s => {
              this.$store
                .dispatch('service/fetchServicePlace', s.id)
                .then(placeData => {
                  const category = this.$t(`places.categories.${placeData.data.category}`)
                  const subject = this.$t(`places.subjects.${placeData.data.subject}`)
                  this.events.push({
                    id: s.id,
                    title: `${placeData.data.alias} (${category} - ${subject})`,
                    specialty: s.specialty ? this.$t(`health_services.${s.specialty}`) : null,
                    startDateTime: this.$moment(s.startDate),
                    endDateTime: this.$moment(s.endDate)
                  })
                })
                .finally(() => this.$vs.loading.close())
            })
        })
        .catch(() => this.$vs.loading.close())
    },
    showSiftDetail(event) {
      this.activePromptSiftDetail = true
      this.showEvent = event
    }
  },
  created() {
    this.$vs.loading()
    if (!moduleEmployee.isRegistered) {
      this.$store.registerModule('employee', moduleEmployee)
      moduleEmployee.isRegistered = true
    }
    if (!modulePlaces.isRegistered) {
      this.$store.registerModule('place', modulePlaces)
      modulePlaces.isRegistered = true
    }
    if (!moduleBusiness.isRegistered) {
      this.$store.registerModule('business', moduleBusiness)
      moduleBusiness.isRegistered = true
    }
    if (!moduleServices.isRegistered) {
      this.$store.registerModule('service', moduleServices)
      moduleServices.isRegistered = true
    }
    this.$store.commit('employee/SET_EMPLOYEES_QUERY', { userId: this.$store.state.AppActiveUser.id })
    this.$store
      .dispatch('employee/fetchEmployees')
      .then(res => {
        this.employeeIds = res.data.employees.map(e => e.id)
      })
      .finally(() => {
        this.setServices()
      })
  }
}
</script>

<style lang="scss">
#operator-shifts-page {
  .vpc_event {
    cursor: pointer !important;
  }
}
</style>
